export const experiences = [
  {
    title: "Associate Software Engineer",
    company: "TrizenAI",
    location: "Chennai, Tamil Nadu",
    period: "April 2025 - Present",
    type: "Full-time",
    responsibilities: [
      "Built REST APIs for Snapflo, a multi-tenant photography studio platform, working with 5+ engineers using NestJS, TypeScript, and PostgreSQL with Drizzle ORM for database schema and migrations",
      "Built photo sharing system using AWS Rekognition for face recognition where guests get their photos automatically via WhatsApp after face matching (S3, Server-Sent Events)",
      "Integrated WhatsApp Business API to automate booking confirmations, payment reminders, and cancellations using Meta compatible templates to avoid manual messaging work by 70%",
      "Built quotation and billing module from scratch with full status lifecycle workflow including database schema, NestJS backend, and React frontend",
      "Implemented RBAC, auth flows, and shipped features through CI/ CD pipelines in Agile sprints with code reviews",
    ],
  },
  {
    title: "Python Full Stack Developer",
    company: "Qspiders Campus Connect",
    location: "Chennai, Tamil Nadu",
    period: "January 2025 - May 2025",
    type: "Internship",
    responsibilities: [
      "Developed real-time web applications using Python, Django, HTML, CSS and JavaScript",
      "Created RESTful APIs and integrated frontend-backend components for dynamic functionality",
      "Gained hands-on experience with MySQL, version control (Git) and deployment practices",
    ],
  },
  {
    title: "Machine Learning Intern",
    company: "Quantanics Private Limited",
    location: "Madurai, Tamil Nadu",
    period: "January 2024 - March 2024",
    type: "Internship",
    responsibilities: [
      "Collaborated with 3 interns and senior developers to implement ML solutions",
      "Led development of Heritage Monument detection web-app using Streamlit and YOLOv8",
      "Worked on autonomous robot creation using NVIDIA Jetson Nano for medicinal plant identification",
    ],
  },
];